<div class="d-flex task-asset-container">
  <file-picker
    [uploadButtonLabel]="label"
    [offlineUpload]="true"
    [emitOfflineAssets]="true"
    (assetsAdded)="onAssetsAdded($event)"
  >
  </file-picker>

  <div class="asset-container">
    <!-- Saved assets -->

    <ng-container *ngIf="task.id && task[onlineAssetsProp] != null">
      <div
        *ngFor="let item of task[onlineAssetsProp]; index as i"
        class="align-middle"
        matTooltip="{{ item?.asset?.name }}"
      >
        <div class="image-container">
          <img
            *ngIf="isImage(item.asset)"
            class="clickable"
            [src]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
            (click)="openLightbox(i, false)"
          />
        </div>
      </div>
    </ng-container>

    <!-- Offline assets -->

    <ng-container *ngIf="task[offlineAssetsProp]?.length > 0">
      <div
        *ngFor="let item of task[offlineAssetsProp]; index as i"
        class="align-middle loaded-img"
        matTooltip="{{ item?.name }}"
      >
        <div class="image-container">
          <img
            *ngIf="isImage(item)"
            class="clickable"
            [src]="item.uuid | assetSource : item.localSafeUrl"
            (click)="openLightbox(i, true)"
          />
        </div>
      </div>
    </ng-container>
  </div>
</div>
